import React, { Component } from "react";
import { connect } from "react-redux";
import Cover from "../../../../Assets/img/default-cover-image.svg";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class SchoolCardV2 extends Component {
  state = {
    values: {
      contact: "",
      password: "",
    },
    schooldata: [],
    loading: false,
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "About";
  }

  render() {
    return (
      <>
          <div className="d-flex th-bg-white m-4 p-2 py-4 th-br-16"
              style={{ border: "2px solid #EAECF0" }}>
            <span>
              <div className="mx-2 my-auto th-br-100"
                style={{ background: "#EFF4FF",  width: "50px" }}>
                <div
                  className="th-login-profile my-auto"
                  style={{
                    backgroundImage: `url(${
                      this.props.user.user.school.logo
                        ? this.props.user.user.school.logo
                        : Cover
                    })`,
                  }}
                ></div>
              </div>
            </span>
            <span className="th-fw-600 th-black th-medium pl-2">
              <p className="mb-0">{this.props.user.user.school.school_name}</p>
              <p className="mb-0 th-grey th-14">
              School Code : {this.props.user.user.school.school_code}
              </p>
            </span>
          </div>
      </>
    );
  }
}
export default connect(mapStateToProps)(SchoolCardV2);
